<template>
  <div class="forum">
    <el-card class="box-card forum-card">
      <div slot="header" class="clearfix">
        <div class="header">
          <a>
            {{ values.name }}
          </a>
        </div>
        <div class="tool hidden-xs-only">
          <div class="forum-item-value">&nbsp;</div>
          <div class="forum-item-ext">
            <div class="forum-item-ext-post-num">
              <span class="text-wch">主题</span>
            </div>
            <div class="forum-item-ext-reply-num">
              <span class="text-wch">回复</span>
            </div>
            <div class="forum-item-ext-reply">
              <span class="text-wch">最新回复</span>
            </div>
          </div>
        </div>
       


      </div>

      <div class="forum-item" v-for="item in values.child" :key="item.id">
        <div class="forum-item-value">
          <el-avatar
            shape="square"
            :size="50"
            fit="fill"
            src="https://img.wch.cn/20250210/wch_info.png"
          ></el-avatar>
          <div class="forum-item-name">
            <div class="forum-item-name-value">
              <router-link :to="{ path: '/forum-' + item.id + '-1.html' }">
                {{ item.name }}
              </router-link>
            </div>
            <div class="forum-item-desc">
              {{ item.description }}
            </div>
            <div class="forum-item-mod" v-if = "item.adminForums && Object.keys(item.adminForums).length >0 ">
              <span>版主：</span>
              <ul >
                <li v-for="mod in item.adminForums.slice(0, 2)" :key="mod.id">
                  <router-link :to="`/u/${mod.userId}`" class="text-wch">
                    {{ mod.nickname }}
                  </router-link>
                </li>
              </ul>
              <!-- <ul class="hidden-sm-and-up">
                <li v-for="mod in item.adminForums.slice(0, 1)" :key="mod.id">
                  <router-link  :to="`/u/${mod.userId}`" class="text-wch">
                    {{ mod.nickname }} ...
                  </router-link>
                </li>
              </ul> -->
            </div>
          </div>
        </div>

        <div class="forum-item-ext hidden-xs-only">
          <div class="forum-item-ext-post-num">
            <span class="text-wch">{{ item.postNum }}</span>
          </div>
          <div class="forum-item-ext-reply-num">
            <span class="text-wch">{{ item.replyNum }}</span>
          </div>
          <div class="forum-item-ext-reply">
            <span> 由:</span>
            <span class="text-highlinght ellipsis-120">{{
              item.lastReplyUser
            }}</span
            >回复
            <div class="forum-item-ext-reply-time">
              {{ $dayjs(item.lastReplyTime).format("YYYY-MM-DD HH:mm:ss") }}
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    values: {
      required: true,
      default: {},
    },
  },
  data() {
    return {
      list: null,
      listLoading: true,
      total: 0,
      pageSize: 10,
      currentPage: 1,
    };
  },
  created() {},

  methods: {
    fetchData() {},
  },
};
</script>
<style lang="less">
.forum-card {
  //border: 1px solid #969696 !important;

  .el-card__header {
    padding: 0;

    .header {
      height: 30px;
      background-color: #1483dc;
      border-radius: 0px;
      padding: 0px;
      text-align: left;
      padding-left: 20px;
      padding-right: 20px;
    }

    .tool {
      height: 20px;
      background-color: #e1dfdf;
      color: #00428b;
      font-size: 12px;
      line-height: 20px;
      display: flex;
      padding-left: 20px;
      padding-right: 20px;
      .forum-item-ext-post-num {
        margin: 0;
      }
      .forum-item-ext-reply-num {
        margin: 0;
      }
      .forum-item-ext-reply {
        margin: 0;
      }
    }
    a {
      font-size: 14px;
      font-weight: bold;

      line-height: 30px;
      color: #ebebeb;
      display: block;
      float: left;
    }
  }

  margin-bottom: 20px;
}


.forum-item-mod {
  display: flex;
  span {
    margin-right: 5px;
  }
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    li {
      margin-right: 5px;
    }
  }
}
.forum-item {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  border-bottom: 1px dashed #969696;
  min-height: 80px;
  display: flex;
  line-height: 20px;
  &:last-child {
    border-bottom: none !important;
  }
}
.forum-item-value {
  display: flex;
  width: 80%;
  @media(max-width: 768px)  {
    width: 100%;
  }
  .el-avatar {
    background-color: #fff;
    margin-top: 15px;
    overflow: visible;
  }
  .forum-item-name {
    margin-left: 10px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    .forum-item-ext-reply {
      line-height: 1;
    }
  }
}
.forum-item-ext {
  width: 320px;
  display: flex;
  //justify-content: flex-end;
  .forum-item-ext-post-num {
    text-align: left;
    width: 50px;
    margin-top: 20px;
  }
  .forum-item-ext-reply-num {
    width: 50px;
    margin-top: 20px;
    text-align: left;
  }
  .forum-item-ext-reply {
    text-align: right;
    margin-top: 20px;
    margin-left: 15px;

    // .forum-item-ext-reply-time {
    //   margin-top: 5px;
    // }
  }
}
</style>
